export const API_LOGIN_URL = "/graphql-mutation-auth"
